import React, { useContext, useEffect, useState } from 'react';
import CustomDialog from '../custom-dialog/custom-dialog';
import {
  CircularProgress,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { AcUnit } from '@mui/icons-material';
import { isMobile, isTablet } from 'react-device-detect';
import FrozenOrders from './frozen-orders';
import FrozenOrdersButton from './frosted-button';
import { AuthContext } from '../../../contexts/user-context/user-context';
import axios from 'axios';
import { API_ENDPOINT } from '../../../configurations/global.config';
import { useSnackBar } from '../../../contexts/snackbar';
import { IconWithText } from '../styles/components';

function FrozenOrdersButtonWithDialog() {
  const [dialogOpen, setDialogOpen] = useState(false);
  const { config } = useContext(AuthContext);
  const [count, setCount] = useState(0);
  const { showMessage } = useSnackBar();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getCount = async () => {
      try {
        const response = await axios.get(
          `${API_ENDPOINT}/api/v1/orders/?page_size=0&include_frozen=true&frozen=true`,
          config
        );
        setCount(response.data.count);
      } catch {
        showMessage('Failed to get frozen orders', 'error');
      } finally {
        setIsLoading(false);
      }
    };

    getCount();
  }, []);

  return (
    <>
      <div>
        {count > 0 && (
          <FrozenOrdersButton
            count={count}
            onClick={() => setDialogOpen(true)}
          />
        )}
      </div>

      {dialogOpen && (
        <CustomDialog
          onClose={() => setDialogOpen(false)}
          open={true}
          maxWidth="xl"
          fullWidth
          fullScreen={(isMobile && !isTablet)}
        >
          <DialogTitle>
            <Typography
              variant="h3"
              component="h3"
              sx={{ textAlign: 'center', mt: 3, mb: 3 }}
            >
              <IconWithText centered>
                <AcUnit fontSize="large" color="primary" /> Frozen Orders
              </IconWithText>
            </Typography>
          </DialogTitle>
          <DialogContent sx={{ mt: 2 }}>
            <FrozenOrders />
          </DialogContent>
        </CustomDialog>
      )}
    </>
  );
}

export default FrozenOrdersButtonWithDialog;
